var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// node_modules/pubsub-js/src/pubsub.js
var require_pubsub = __commonJS({
  "node_modules/pubsub-js/src/pubsub.js"(exports, module) {
    (function(root, factory) {
      "use strict";
      var PubSub2 = {};
      if (root.PubSub) {
        PubSub2 = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
      } else {
        root.PubSub = PubSub2;
        factory(PubSub2);
      }
      if (typeof exports === "object") {
        if (module !== void 0 && module.exports) {
          exports = module.exports = PubSub2;
        }
        exports.PubSub = PubSub2;
        module.exports = exports = PubSub2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return PubSub2;
        });
      }
    })(typeof window === "object" && window || exports || global, function(PubSub2) {
      "use strict";
      var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
      function hasKeys(obj) {
        var key;
        for (key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return true;
          }
        }
        return false;
      }
      function throwException(ex) {
        return function reThrowException() {
          throw ex;
        };
      }
      function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
          subscriber(message, data);
        } catch (ex) {
          setTimeout(throwException(ex), 0);
        }
      }
      function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
      }
      function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
          return;
        }
        for (s in subscribers) {
          if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
            callSubscriber(subscribers[s], originalMessage, data);
          }
        }
      }
      function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
          var topic = String(message), position = topic.lastIndexOf(".");
          deliverMessage(message, message, data, immediateExceptions);
          while (position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            deliverMessage(message, topic, data, immediateExceptions);
          }
          deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
      }
      function hasDirectSubscribersFor(message) {
        var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
        return found;
      }
      function messageHasSubscribers(message) {
        var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
        while (!found && position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          found = hasDirectSubscribersFor(topic);
        }
        return found;
      }
      function publish(message, data, sync, immediateExceptions) {
        message = typeof message === "symbol" ? message.toString() : message;
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
          return false;
        }
        if (sync === true) {
          deliver();
        } else {
          setTimeout(deliver, 0);
        }
        return true;
      }
      PubSub2.publish = function(message, data) {
        return publish(message, data, false, PubSub2.immediateExceptions);
      };
      PubSub2.publishSync = function(message, data) {
        return publish(message, data, true, PubSub2.immediateExceptions);
      };
      PubSub2.subscribe = function(message, func) {
        if (typeof func !== "function") {
          return false;
        }
        message = typeof message === "symbol" ? message.toString() : message;
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
          messages[message] = {};
        }
        var token = "uid_" + String(++lastUid);
        messages[message][token] = func;
        return token;
      };
      PubSub2.subscribeAll = function(func) {
        return PubSub2.subscribe(ALL_SUBSCRIBING_MSG, func);
      };
      PubSub2.subscribeOnce = function(message, func) {
        var token = PubSub2.subscribe(message, function() {
          PubSub2.unsubscribe(token);
          func.apply(this, arguments);
        });
        return PubSub2;
      };
      PubSub2.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
      };
      PubSub2.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            delete messages[m];
          }
        }
      };
      PubSub2.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var token;
        var count = 0;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            for (token in messages[m]) {
              count++;
            }
            break;
          }
        }
        return count;
      };
      PubSub2.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            list.push(m);
          }
        }
        return list;
      };
      PubSub2.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
          var m2;
          for (m2 in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
              return true;
            }
          }
          return false;
        }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction = typeof value === "function", result = false, m, message, t;
        if (isTopic) {
          PubSub2.clearSubscriptions(value);
          return;
        }
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m)) {
            message = messages[m];
            if (isToken && message[value]) {
              delete message[value];
              result = value;
              break;
            }
            if (isFunction) {
              for (t in message) {
                if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                  delete message[t];
                  result = true;
                }
              }
            }
          }
        }
        return result;
      };
    });
  }
});

// src/utils/constants.js
var PUB_SUB_EVENTS = {
  colorChange: "color-change",
  sizeChange: "size-change",
  variantChange: "variant-change",
  blindsChange: "blinds-change",
  initialize: "initialize",
  onlyUpdateUrl: "only-update-url",
  blindsUpdatePrice: "blinds-update-price",
  updateControls: "update-controls",
  upsellChange: "upsell-change"
};

// src/utils/body-lock.js
var BodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
  }
};
var body_lock_default = new BodyLock();

// src/extenders/surf-modal.js
var _hideOnClickOutside, hideOnClickOutside_fn, _addCloseEventListener, addCloseEventListener_fn, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn, _sendCustomEvent, sendCustomEvent_fn;
var SurfModal = class {
  constructor() {
    __privateAdd(this, _hideOnClickOutside);
    /**
     * Add close event listener
     */
    __privateAdd(this, _addCloseEventListener);
    /**
     * Get correct modal by target id
     *
     * @param {string} targetId
     *
     * @returns {element}
     */
    __privateAdd(this, _getCorrectModalByTargetId);
    __privateAdd(this, _sendCustomEvent);
  }
  /**
   * Open modal.
   */
  openModal(targetId, triggerElement, deeplinkTarget) {
    const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
    if (modal) {
      modal.classList.remove("initial-load");
      modal.classList.add("js-modal-open");
      modal.setAttribute("aria-hidden", "false");
      modal.setAttribute("aria-expanded", "true");
      __privateMethod(this, _addCloseEventListener, addCloseEventListener_fn).call(this, modal, targetId);
      __privateMethod(this, _hideOnClickOutside, hideOnClickOutside_fn).call(this, modal, targetId);
      body_lock_default.lock();
      __privateMethod(this, _sendCustomEvent, sendCustomEvent_fn).call(this, "open", targetId, triggerElement, deeplinkTarget);
    }
  }
  /**
   * Close modal.
   */
  closeModal(targetId) {
    const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
    if (modal) {
      modal.classList.remove("js-modal-open");
      modal.setAttribute("aria-hidden", "true");
      modal.setAttribute("aria-expanded", "false");
      body_lock_default.unlock();
      __privateMethod(this, _sendCustomEvent, sendCustomEvent_fn).call(this, "close", targetId);
    }
  }
  /**
   * Get current state of the cart modal.
   *
   * @returns {{state: string, isCartOpen: boolean}}
   */
  getCurrentState(targetId) {
    const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
    if (modal.classList.contains("js-modal-open")) {
      return {
        state: "open",
        isModalOpen: true
      };
    } else {
      return {
        state: "closed",
        isModalOpen: false
      };
    }
  }
};
_hideOnClickOutside = new WeakSet();
hideOnClickOutside_fn = function(modal, targetId) {
  const outsideClickListener = (event) => {
    const target = event.target;
    const allModalOpeners = document.querySelectorAll(".js-open-modal");
    const arrayAllModalOpeners = [...allModalOpeners];
    if (target !== modal && target.closest(".modal") || arrayAllModalOpeners.filter(
      (modalOpener) => modalOpener === target.closest(".js-open-modal")
    ).length !== 0) {
    } else {
      this.closeModal(targetId);
      removeClickListener();
    }
  };
  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };
  document.addEventListener("click", outsideClickListener);
};
_addCloseEventListener = new WeakSet();
addCloseEventListener_fn = function(modal, targetId) {
  const allCloseModalButtons = modal.querySelectorAll(".js-close-modal");
  const submitButton = modal.querySelector(".js-modal-submit");
  if (allCloseModalButtons) {
    allCloseModalButtons.forEach((closeModalButton2) => {
      const closeClick = () => {
        this.closeModal(targetId);
        removeClickListener();
      };
      const removeClickListener = () => {
        closeModalButton2.removeEventListener("click", closeClick);
      };
      closeModalButton2.addEventListener("click", () => {
        closeClick();
      });
    });
  }
  if (submitButton) {
    const closeClick = () => {
      this.closeModal(targetId);
      removeClickListener();
    };
    const removeClickListener = () => {
      closeModalButton.removeEventListener("click", closeClick);
    };
    submitButton.addEventListener("click", closeClick);
  }
};
_getCorrectModalByTargetId = new WeakSet();
getCorrectModalByTargetId_fn = function(targetId) {
  const modalChild = document.querySelector(`#${targetId}`);
  const modalElement = modalChild ? modalChild.closest(".modal") : null;
  if (modalElement)
    return modalElement;
};
_sendCustomEvent = new WeakSet();
sendCustomEvent_fn = function(state, targetId, triggerElement, deeplinkTarget) {
  const event = new CustomEvent("modal-state", {
    detail: {
      state,
      targetId: `${targetId}`,
      element: triggerElement ? triggerElement : null,
      deeplinkTarget
    }
  });
  document.dispatchEvent(event);
};
var surf_modal_default = SurfModal;

// src/extenders/cart-drawer.js
var import_pubsub_js = __toESM(require_pubsub(), 1);
if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "updateCartUnsubscriber");
        this.targetId = "cart";
        this.baseModal = new surf_modal_default();
        this.isCartModalOpen = this.baseModal.getCurrentState(this.targetId);
      }
      connectedCallback() {
        this.updateCartUnsubscriber = import_pubsub_js.PubSub.subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          this.updateCart.bind(this)
        );
      }
      disconnectedCallback() {
        import_pubsub_js.PubSub.unsubscribe(this.updateCartUnsubscriber);
      }
      updateCart(sub, { cartData }) {
        if (cartData) {
          const selectors = this.getSectionsToRender();
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector.selector);
            const selectedSourceElement = new DOMParser().parseFromString(cartData.sections[selector.id], "text/html");
            const sourceElement = selectedSourceElement.querySelector(selector.selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        }
        this.setAttribute("aria-hidden", false);
        this.setAttribute("aria-expanded", true);
        this.baseModal.openModal(this.targetId);
      }
      getSectionsToRender() {
        return [
          {
            id: "cart-items",
            section: "cart-items",
            selector: "#cart-items"
          },
          {
            id: "cart-item-counter",
            section: "cart-item-counter",
            selector: "#cart-item-counter"
          },
          {
            id: "cart-summary",
            section: "cart-summary",
            selector: "#cart-summary"
          }
        ];
      }
    }
  );
}
